export default __webpack_public_path__ + "images/banner-girl.81cb046abf56be5755bad58d665a2ea6.png";